import React from 'react';

const ChatGPTLaunch = () => (
  <article className="news-article-body">
    <p className="news-lead">
      On <strong>November 30, 2022</strong>, OpenAI published a single blog post and CEO Sam Altman
      sent a single tweet announcing a "low-key research preview" of ChatGPT. Servers crashed
      in Japan within hours. Within two months it had 100 million users — the fastest consumer
      product adoption in history at the time. Within two years: 300 million weekly users and
      $4 billion in annual revenue.
    </p>

    <h2>What Was ChatGPT?</h2>
    <p>
      ChatGPT is a fine-tuned version of <strong>GPT-3.5</strong> — itself an improved successor
      to GPT-3, trained on a blend of text and code up to Q3 2021. The key innovation was not
      the model's raw capability (GPT-3 already existed), but its <strong>conversational interface</strong>
      and the use of <strong>Reinforcement Learning from Human Feedback (RLHF)</strong> to make
      it helpful, harmless, and honest.
    </p>
    <p>
      RLHF involved human trainers rating model responses and acting as both user and assistant
      in simulated conversations. This created the "assistant" behaviour that prior GPT models lacked.
    </p>

    <h2>Why It Hit Differently</h2>
    <p>
      Previous AI demos had impressed researchers but failed to cross into general public
      consciousness. ChatGPT succeeded because:
    </p>
    <ul>
      <li>
        <strong>Zero friction</strong>: Free, browser-based, no technical setup required.
        Anyone with an email address could try it immediately.
      </li>
      <li>
        <strong>Conversational interface</strong>: Humans naturally understand dialogue.
        Unlike APIs or form-based tools, ChatGPT felt like talking to a knowledgeable person.
      </li>
      <li>
        <strong>Broad competence</strong>: It could write code, essays, poems, emails, and explain
        complex topics — the first time a single tool demonstrated cross-domain fluency.
      </li>
      <li>
        <strong>Timing</strong>: Released at the peak of pandemic-driven remote work adoption,
        when knowledge workers were actively seeking productivity tools.
      </li>
    </ul>

    <h2>The Moment at NeurIPS 2022</h2>
    <p>
      ChatGPT launched during the NeurIPS conference, the world's leading AI research gathering.
      The model became the dominant conversation topic overnight. Academic researchers who had
      spent years on benchmark-chasing systems found themselves outflanked by a product decision:
      make it accessible.
    </p>

    <h2>The Industry Scramble That Followed</h2>
    <p>
      ChatGPT's launch triggered a crisis at Google, which issued a "code red" and rushed
      Bard (later Gemini) to market. Microsoft invested $10 billion in OpenAI and integrated
      ChatGPT into Bing and Office 365. Meta released LLaMA weights. Anthropic launched Claude.
      The modern AI arms race began on November 30, 2022.
    </p>

    <h2>From Research Preview to Global Infrastructure</h2>
    <p>
      Within two years, ChatGPT evolved from a research demo into a platform: custom GPTs,
      an API powering thousands of applications, voice mode, image generation (DALL-E 3),
      Advanced Data Analysis, and deep integrations into enterprise software stacks. The
      "research preview" became the foundation of a $4B revenue engine.
    </p>

    <div className="news-insight-box">
      <h3>Key Takeaway</h3>
      <p>
        ChatGPT's success was less about technical breakthroughs (GPT-3 predated it by over
        two years) and more about product design. The lesson: accessibility and user experience
        determine technology adoption as much as raw capability. Every major AI development
        since November 2022 traces its urgency back to this single launch.
      </p>
    </div>
  </article>
);

export default ChatGPTLaunch;
